module.exports = __webpack_public_path__ + "img/ece46eabd47c684204fe8d1fee4c332f.png";